export default __webpack_public_path__ + "static/media/slider-convertibleNote-M.35ac41ff.png";